import { yupResolver } from '@hookform/resolvers/yup';
import type { ReactNode } from 'react';
import { useForm, UseFormGetValues } from 'react-hook-form';

import type {
  Control,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormRegisterReturn,
  UseFormResetField,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form';
import type { OptionalObjectSchema } from 'yup/lib/object';

export type ExportedProps = {
  fields: { [key: string]: UseFormRegisterReturn };
  handleSubmit: UseFormHandleSubmit<any>;
  errors: any;
  resetField: UseFormResetField<any>;
  trigger: UseFormTrigger<any>;
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
  control: Control;
  register: UseFormRegister<any>;
};

type FormProps = {
  initialValues: {
    [key: string]: any;
  };
  validationSchema: OptionalObjectSchema<any>;
  children: (props: ExportedProps) => ReactNode;
  className?: string;
};

const Form = ({ children, initialValues, validationSchema, className }: FormProps) => {
  const resolver = yupResolver(validationSchema);

  const formState = useForm({
    defaultValues: initialValues,
    resolver,
    mode: 'onSubmit',
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    trigger,
    watch,
    setValue,
    getValues,
    control,
  } = formState;

  const fields = Object.keys(initialValues).reduce(
    (previousValue, currentValue) => ({ ...previousValue, [currentValue]: register(currentValue) }),
    {}
  );

  return (
    <form className={className}>
      {children({
        fields,
        errors,
        handleSubmit,
        resetField,
        trigger,
        watch,
        setValue,
        control,
        register,
        getValues,
      })}
    </form>
  );
};

export default Form;
